import PageTitle from '@/components/PageTitle';
import classes from './index.module.css';
import AccountSettings from './AccountSettings';

export default function OrgSettings() {
  return (
    <div className={classes.wrapper}>
      <PageTitle title="Profile" />
      <div className={classes.content}>
        <div className={classes.main}>
          <AccountSettings />
        </div>
      </div>
    </div>
  );
}
